import React from 'react';
import { connect } from 'react-redux';
import { getMessage } from '../../reducers/selectors';

const Translatable = ({ message, className, key, children }) =>
    <React.Fragment>
        <span className={className} key={key}>
            {message}
            {children}
        </span>


    </React.Fragment>;

const makeMapStateToProps = (initialState, initialOwnProps) => {
    const { message } = initialOwnProps;
    const mapStateToProps = state => (
        {
            message: getMessage(state, message),
        }
    );
    return mapStateToProps;
};

export default connect(makeMapStateToProps)(Translatable);



// WEBPACK FOOTER //
// ./src/components/common/Translatable.js